import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const DiamondIcon = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      fill="#000"
      d="M12 21.15 2.643 9.91l2.693-5.376h13.338l2.684 5.377L12 21.15ZM8.756 9.534h6.489L13.21 5.457h-2.412L8.756 9.534Zm2.788 9.633v-8.71H4.313l7.23 8.71Zm.923 0 7.23-8.71h-7.23v8.71Zm3.807-9.633h3.845l-2.033-4.077H14.23l2.043 4.077Zm-12.393 0h3.855L9.77 5.457H5.924L3.881 9.534Z"
    />
  </Svg>
)
export default DiamondIcon
